<template>
    <div class="error-message">{{ message }}</div>
</template>
<script>
export default {
    props: ['message'],
};
</script>
